(function () {
  const section = document.querySelector('.header-section');
  const layers = section ? section.querySelectorAll('.layer') : [];

  if (!layers.length) return;

  const speedMap = {
    'layer-0': 0.4,
    'layer-1': 0.25,
    'layer-2': 0.15,
    'layer-3': 0.05,
  };

  let ticking = false;

  function updateParallax() {
    const scrollY = window.scrollY;

    const sectionBottom = section.getBoundingClientRect().bottom;

    if (sectionBottom < 0) return;

    layers.forEach(layer => {
      const key = Array.from(layer.classList).find(cls => cls.startsWith('layer-'));
      const speed = speedMap[key] ?? 0.1;

      const yOffset = scrollY * speed;
      layer.style.transform = `translate3d(0px, ${yOffset}px, 0px)`;
    });
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();